// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609172334/js/" + chunkId + "." + {"44":"2cee155c","225":"a6df99f8","481":"0e28cac5","486":"8096e438","770":"9ee1509f"}[chunkId] + ".0.861841495249547.chunk.js";
};